import styled from 'styled-components';

import { BREAKPOINTS, COLORS } from 'utils/constants';

const PageTitle = styled.span`
    position: relative;
    transform: translate(0, -.125rem);
    display: inline-block;
    height: 1.25rem;
    padding-left: .75rem;
    margin-left: .75rem;
    line-height: 1.25rem;
    color: ${COLORS.siteBlue};
    
    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: .125rem;
        height: 1.25rem;
        background: ${COLORS.siteLightGrey};
    }
    
    @media screen and (max-width: ${BREAKPOINTS.smallTabletBreakpoint}) {
        font-size: .875rem;
    }
    
    @media screen and (min-width: ${BREAKPOINTS.smallTabletBreakpoint}) {
        height: 2.25rem;
        margin-left: 1.625rem;
        padding-left: 1.625rem;
        line-height: 3rem;
        
        &:before {
            top: .25rem;
            height: 2.5rem;
        }
    }
`;

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/Header/PageTitle.js